export default Object.freeze({
  IDLE: Symbol('IDLE'),
  IN_PROGRESS: Symbol('IN_PROGRESS'),
  SUCCEEDED: Symbol('SUCCEEDED'),
  FAILED: Symbol('FAILED'),
});
